import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    fetchAllTransactions(farm, date) {
        const options = {
            method: 'get',
            url: `/umbraco/api/StockReconciliation/gettransactions?farm=${farm}&date=${date}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSummary(farm, date) {
        const options = {
            method: 'get',
            url: `/umbraco/api/StockReconciliation/getsummary?farm=${farm}&date=${date}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingle(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/StockReconciliation/getsingle?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    delete(id) {

        const options = {
            method: 'delete',
            url: `/umbraco/api/StockReconciliation/delete?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    add(transaction) {

        const options = {
            method: 'post',
            url: `/umbraco/api/StockReconciliation/Add`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: transaction
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    update(transaction) {

        const options = {
            method: 'put',
            url: `/umbraco/api/StockReconciliation/Update`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: transaction
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    createMedia(image) {

        const options = {
            method: 'post',
            url: `/umbraco/api/StockReconciliation/CreateMedia`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: image
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }
}